import { render, staticRenderFns } from "./AppointmentSla.vue?vue&type=template&id=54fd97f8"
import script from "./AppointmentSla.vue?vue&type=script&lang=js"
export * from "./AppointmentSla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports